// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import FileUpload from "../../components/common/FileUpload";
// import { DataGrid } from '@mui/x-data-grid';
// import Loader from "../../components/common/Loader";
// import Badge from '@mui/material/Badge';
// import axios from "axios";
// import AsyncSelect from "react-select/async";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//     faPlus, faMagnifyingGlass, faEllipsisVertical, // Add this
//     faDownload, // Add this
//     faUpload,
//     faUserCheck,
// } from '@fortawesome/free-solid-svg-icons';
// import { green, yellow, red } from '@mui/material/colors';
// import { SERVER_ORIGIN, validation } from "../../utilities/constants";
// import HeaderCard from "../../components/common/HeaderCard";
// // import { refreshScreen } from "../../utilities/helper_functions";
// import SecCard from "../../components/common/SecCard";
// import { Row, Col } from "react-bootstrap";

// import css from "../../css/admin/users-page.module.css";
// import DownloadExcel from "../../components/common/DownloadExcel";
// import YuvaEcAssignmentModal from "../../components/common/YuvaEcAssignmentModal";
// import BackButton from "../../components/common/BackButton";
// import { hasReadOnlyAccess, getManageStudentsPath, getDashboardPath } from "../../utilities/helper_functions";


// // localhost:800/users/all?page=1&limit=10&search=abhishek&sortBy=fName&sortType=desc

// function capitalizeFirstLetter(str) {
//     return str.charAt(0).toUpperCase() + str.substr(1);
// }

// const InstutueStudents = () => {
//     const [searchParams] = useSearchParams();
//     const tabFromUrl = searchParams.get("tab");
//     const [activeTab, setActiveTab] = useState(tabFromUrl || "institute");
//     // const [activeTab, setActiveTab] = useState('institute'); // Add tab state
//     const [instituteType, setInstituteType] = useState(null); // Track institute type
//     const [queryId, setQueryId] = useState("")
//     const [isLoading, setIsLoading] = useState(false);
//     const [limit, setLimit] = useState(0);
//     const [allUsers, setAllUsers] = useState([]);
//     const [page, setPage] = useState(1);
//     const [sortType, setSortType] = useState(true);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [totalPages, setTotalPages] = useState(0);
//     const [colleges, setColleges] = useState([]);
//     const [searchCollege, setSearchCollege] = useState("");
//     // const [isDropDownOpen, setIsDropDownOpen] = useState(false);
//     const [rerender, setRerender] = useState(true);
//     const isReadOnly = hasReadOnlyAccess();
//     const downloadExcelRef = useRef(null);
//     const fileUploadRef = useRef(null);
//     // YUVA EC Assignment Modal state
//     const [showEcModal, setShowEcModal] = useState(false);
//     const [selectedStudent, setSelectedStudent] = useState(null);
//     // New state for filters
//     const [filters, setFilters] = useState({
//         region: "",
//         state: "",
//         onboardingStatus: "",
//         emailStatus: "",
//         collegeName: "",
//     });




//     // Get unique values for dropdowns
//     const uniqueRegions = [
//         ...new Set(allUsers.map((item) => item.region).filter(Boolean)),
//     ];
//     const uniqueStates = [
//         ...new Set(allUsers.map((item) => item.state).filter(Boolean)),
//     ];
//     const uniqueColleges = [
//         ...new Set(allUsers.map((item) => item.collegeName).filter(Boolean)),
//     ];
//     // const [rowIndexCounter, setRowIndexCounter] = useState(0)
//     // console.log("page is openid");
//     const renderOnboardingStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'invited':
//                 statusColor = yellow[500];
//                 statusText = 'Invited';
//                 textColor = "black";
//                 break;
//             case 'pending':
//                 statusColor = red[500];
//                 statusText = 'Pending';
//                 textColor = "white";
//                 break;
//             case 'onboarded':
//                 statusColor = green[500];
//                 statusText = 'Onboarded';
//                 textColor = "white";
//                 break;
//             default:
//                 statusColor = 'transparent';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return <Badge>
//             <span style={{ backgroundColor: statusColor, padding: '6.4px 16px', borderRadius: '8px', color: textColor }}>
//                 {statusText}
//             </span>
//         </Badge>
//     }
//     const renderEmailStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'sent':
//                 statusColor = green[500];
//                 statusText = 'Sent';
//                 textColor = "white";
//                 break;
//             case 'not sent':
//                 statusColor = red[500];
//                 statusText = 'Not Sent';
//                 textColor = "white";
//                 break;
//             default:
//                 statusColor = 'transparent';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return <Badge >
//             <span style={{ borderRadius: '8px', backgroundColor: statusColor, padding: '6.4px 16px', color: textColor }}>
//                 {statusText}
//             </span>
//         </Badge>
//     }

//     const renderRegistrationType = (params) => {
//         const isPublic = params.row.isPublicRegistration || false;
//         return (
//             <Badge>
//                 <span style={{
//                     backgroundColor: isPublic ? "#007bff" : "#6c757d",
//                     padding: "4px 8px",
//                     borderRadius: "6px",
//                     color: "white",
//                     fontSize: "11px",
//                     fontWeight: "500"
//                 }}>
//                     {isPublic ? "Public Link" : "Regular"}
//                 </span>
//             </Badge>
//         );
//     };
//     const renderYuvaECStatus = (params) => {
//         const isEC = params.row.isYuvaEC || false;
//         const ecPosition = params.row.yuvaEcPosition || "";
//         const effectiveFrom = params.row.yuvaEcEffectiveFrom;
//         const effectiveTo = params.row.yuvaEcEffectiveTo;

//         const now = new Date();
//         const fromDate = effectiveFrom ? new Date(effectiveFrom) : null;
//         const toDate = effectiveTo ? new Date(effectiveTo) : null;
//         const isActive = fromDate && toDate && now >= fromDate && now <= toDate;

//         if (isEC && isActive) {
//             return (
//                 <Badge>
//                     <span style={{
//                         backgroundColor: green[500],
//                         padding: "6.4px 16px",
//                         borderRadius: "8px",
//                         color: "white",
//                         fontSize: "12px"
//                     }}>
//                         {ecPosition || "YUVA EC"}
//                     </span>
//                 </Badge>
//             );
//         } else if (isEC && !isActive) {
//             return (
//                 <Badge>
//                     <span style={{
//                         backgroundColor: yellow[600],
//                         padding: "6.4px 16px",
//                         borderRadius: "8px",
//                         color: "white",
//                         fontSize: "12px"
//                     }}>
//                         Expired
//                     </span>
//                 </Badge>
//             );
//         } else {
//             return (
//                 <Badge>
//                     <span style={{
//                         backgroundColor: "#f5f5f5",
//                         padding: "6.4px 16px",
//                         borderRadius: "8px",
//                         color: "#666",
//                         fontSize: "12px"
//                     }}>
//                         Not Assigned
//                     </span>
//                 </Badge>
//             );
//         }
//     };

//     const baseColumns = [
//         { field: 'id', headerName: 'ID', align: 'center', width: 90 },
//         { field: 'fName', headerName: 'Full Name', align: 'center', width: 170, valueGetter: (params) => `${params.row.fName || ''} ${params.row.lName || ''}`.trim() },
//         { field: 'email', headerName: 'Email', align: 'center', width: 200 },
//         { field: 'collegeName', headerName: 'Institute Name', align: 'center', width: 170 },
//         { field: 'passOutYear', headerName: 'Passout Year', align: 'center', width: 150 },
//         { field: 'chapterName', headerName: 'Chapter Name', align: 'center', width: 150 },
//         { field: 'region', headerName: 'Region', align: 'center', width: 150 },
//         { field: 'onboardingSatus', headerName: 'Onboarding Status', align: 'center', width: 160, renderCell: renderOnboardingStatus },
//         { field: 'registrationType', headerName: 'Registration Type', align: 'center', width: 150, renderCell: renderRegistrationType },
//         { field: 'gender', headerName: 'Gender', align: 'center', width: 110 },
//         { field: 'branch', headerName: 'Branch', align: 'center', width: 110 },
//     ];
//     const ecColumns = [
//         {
//             field: 'yuvaEcStatus',
//             headerName: 'YUVA EC Status',
//             align: 'center',
//             width: 150,
//             renderCell: renderYuvaECStatus,
//         },
//         {
//             field: 'assignEC',
//             headerName: 'Assign YUVA EC',
//             type: 'actions',
//             width: 180,
//             align: 'center',
//             renderCell: (params) => (
//                 <button
//                     className={css.editBtn}
//                     style={{ backgroundColor: '#28a745', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
//                     onClick={() => { setSelectedStudent(params.row); setShowEcModal(true); }}
//                 >
//                     Assign YUVA EC
//                 </button>
//             )
//         }
//     ];
//     const columns = activeTab === 'institute'
//         ? [...baseColumns, ...ecColumns]  // show EC columns
//         : [...baseColumns];               // hide EC columns for thalir

//     const rows = allUsers.map((user, idx) => ({ ...user, 'id': idx + 1 }))
//     const navigate = useNavigate();

//     function handleUsersClick() {
//         navigate(`/user/register/${queryId}`);
//     }

//     useEffect(() => {
//         async function getAllUsers() {
//             // console.log("akshgjahskjhgj");
//             try {
//                 setIsLoading(true);
//                 const _id = sessionStorage.getItem('_id');
//                 setQueryId(_id)
//                 // const adminId = process.env.REACT_APP_ADMIN_ID;
//                 // const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
//                 // const basicAuth = btoa(`${adminId}:${adminPassword}`);
//                 const response = await fetch(
//                     `${SERVER_ORIGIN}/api/institute/auth/users/all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=fName&sortType=${sortType === true ? "asc" : "desc"}`,
//                     {
//                         method: "POST",
//                         headers: {
//                             "Content-Type": "application/json",
//                             "auth-token": sessionStorage.getItem("token"),
//                             //Authorization: `Basic ${basicAuth}`,
//                         }, body: JSON.stringify({ _id: _id }),
//                     }
//                 );

//                 const result = await response.json();

//                 setIsLoading(false);

//                 if (response.status >= 400 && response.status < 600) {
//                     if (response.status === 401) {
//                         navigate("/");
//                     } else if (response.status === 500) {
//                         toast.error(result.statusText);
//                     }
//                 } else if (response.ok && response.status === 200) {
//                     setAllUsers(result.filteredUsers);
//                     setTotalPages(result.totalPages);
//                 } else {
//                     // for future
//                 }
//             } catch (err) {
//                 setIsLoading(false);
//             }

//         }
//         getAllUsers();
//     }, [page, sortType, searchQuery]); // Remove activeTab dependency
//     const pageSizeOptions = [5, 10, 20, 50, 100, 7];
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [defaultOptions, setDefaultOptions] = useState([]);
//     const [regisForm, setRegisForm] = useState({
//         userId: "",
//         email: "",
//         fName: "",
//         mName: "",
//         lName: "",
//         collegeName: "",
//         region: "",
//         branch: "",
//         phone: "",
//         addLine1: "",
//         addLine2: "",
//         city: "",
//         pincode: "",
//         country: "India",
//         state: "",
//         passOutYear: "",
//         createdBy: handelCreatedBy()
//     });
//     function handelCreatedBy() {
//         if (sessionStorage.getItem('token') !== null) {
//             return sessionStorage.getItem('_id')
//         } else {
//             return ""
//         }
//     }
//     const loadOptions = async (inputValue, callback) => {

//         try {
//             const response = await axios.get(`${SERVER_ORIGIN}/api/institute/auth/institute/all`, {
//                 params: {
//                     search: inputValue,
//                     page: 1,
//                     limit: 10,
//                     sortBy: "name",
//                     sortType: "asc",
//                     id: sessionStorage.getItem('_id'),
//                     isThalir: activeTab === 'thalir' ? 'true' : 'false'
//                 }
//             });
//             const options = response.data.filteredInstitutes.map(institute => ({
//                 label: institute.name,
//                 value: institute._id,
//                 state: institute.state,
//                 city: institute.city
//             }));
//             callback(options);
//         } catch (error) {
//             console.error("Error fetching institutes", error);
//         }
//     };

//     useEffect(() => {
//         const fetchDefaultOptions = async () => {
//             try {
//                 const response = await axios.get(`${SERVER_ORIGIN}/api/institute/auth/institute/all`, {
//                     params: {
//                         search: '',
//                         page: 1,
//                         limit: 5,
//                         sortBy: "name",
//                         sortType: "asc",
//                         id: sessionStorage.getItem('_id'),
//                         isThalir: activeTab === 'thalir' ? 'true' : 'false'
//                     }
//                 });
//                 const options = response.data.filteredInstitutes.map(institute => ({
//                     label: institute.name,
//                     value: institute._id,
//                     state: institute.state,
//                     city: institute.city
//                 }));
//                 setDefaultOptions(options);
//             } catch (error) {
//                 console.error("Error fetching default options", error);
//             }
//         };

//         fetchDefaultOptions();
//     }, [activeTab]); // Add activeTab dependency

//     useEffect(() => {
//         const getInstituteDetails = async () => {
//             try {
//                 const _id = sessionStorage.getItem('_id');
//                 const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/users/${_id}`, {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'auth-token': sessionStorage.getItem('token'),
//                     },
//                 });

//                 if (response.ok) {
//                     const result = await response.json();
//                     const isThalir = result.user?.isThalir || false;
//                     setInstituteType(isThalir ? 'thalir' : 'institute');
//                     setActiveTab(isThalir ? 'thalir' : 'institute');
//                 }
//             } catch (error) {
//                 console.error('Error fetching institute details:', error);
//             }
//         };

//         getInstituteDetails();
//     }, []);

//     // Reusable stat card with icon and soft gradient
//     const StatCard = ({ title, value, icon, gradient }) => (
//         <ElevateOnHover>
//             <div className={css.dashboardCard} style={{ overflow: "hidden" }}>
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         padding: "12px 16px",
//                     }}
//                 >
//                     <h3
//                         className={css.cardTitle}
//                         style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}
//                     >
//                         {title}
//                     </h3>
//                     <div
//                         style={{
//                             width: 36,
//                             height: 36,
//                             borderRadius: 10,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: gradient,
//                             color: "#fff",
//                         }}
//                     >
//                         <FontAwesomeIcon icon={icon} />
//                     </div>
//                 </div>
//                 <div className={css.cardContent} style={{ paddingTop: 0 }}>
//                     <div className={css.mainNumber}>{value}</div>
//                 </div>
//             </div>
//         </ElevateOnHover>
//     );
//     // Handle filter changes
//     const handleFilterChange = (filterName, value) => {
//         setFilters((prev) => ({
//             ...prev,
//             [filterName]: value,
//         }));
//     };

//     // Clear all filters
//     const clearAllFilters = () => {
//         setFilters({
//             region: "",
//             state: "",
//             onboardingStatus: "",
//             emailStatus: "",
//             collegeName: "",
//         });
//         setSearchQuery("");
//     };

//     // Apply filters to data
//     const filteredUsers = allUsers.filter((user) => {
//         return (
//             (!filters.region || user.region === filters.region) &&
//             (!filters.state || user.state === filters.state) &&
//             (!filters.onboardingStatus ||
//                 user.onboardingSatus === filters.onboardingStatus) &&
//             (!filters.emailStatus || user.emailSentStatus === filters.emailStatus) &&
//             (!filters.collegeName || user.collegeName === filters.collegeName)
//         );
//     });
//     const ElevateOnHover = ({ children }) => {
//         const [hovered, setHovered] = useState(false);
//         return (
//             <div
//                 onMouseEnter={() => setHovered(true)}
//                 onMouseLeave={() => setHovered(false)}
//                 style={{
//                     borderRadius: 12,
//                     background: "#ffffff",
//                     transition: "box-shadow 200ms ease, transform 200ms ease",
//                     boxShadow: hovered
//                         ? "0 8px 24px rgba(16,24,40,.12)"
//                         : "0 1px 3px rgba(16,24,40,.06)",
//                     transform: hovered ? "translateY(-2px)" : "none",
//                 }}
//             >
//                 {children}
//             </div>
//         );
//     };

//     return (
//         <div className={css.outerDiv}>
//             <div className={css.headerSection}>
//                 <div className={css.headerLeft}>
//                     <BackButton
//                         text="Back to Dashboard"
//                         customPath={getDashboardPath()}
//                     />
//                 </div>
//             </div>
//             {isReadOnly && (
//                 <div className={css.readOnlyAlert}>
//                     <div className="alert alert-info" role="alert">
//                         <strong>Read-Only Access:</strong> You can view all student data but
//                         cannot add, edit, or upload new students.
//                     </div>
//                 </div>
//             )}
//             <div className="my-4">
//                 <SecCard>
//                     <Row className="g-4">
//                         <div
//                             className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
//                         >
//                             <div className={css.serviceName}>Students Data</div>

//                             <div className={css.headerRightSection}>
//                                 {!isReadOnly && (
//                                     <div className={css.actionButtons}>
//                                         <button className={css.addBtn} onClick={handleUsersClick}>
//                                             <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
//                                             Add Student
//                                         </button>

//                                         <ActionsDropdown
//                                             onDownload={() =>
//                                                 document
//                                                     .querySelector(`.${css.downloadExcelBtn}`)
//                                                     ?.click()
//                                             }
//                                             onUpload={() =>
//                                                 document.querySelector(`.${css.fileUploadBtn}`)?.click()
//                                             }
//                                         />

//                                         {/* Hidden triggers for download and upload */}
//                                         <div style={{ display: "none" }}>
//                                             <DownloadExcel
//                                                 ref={downloadExcelRef}
//                                                 className={css.downloadExcelBtn}
//                                             />
//                                             <FileUpload
//                                                 ref={fileUploadRef}
//                                                 collegeName={selectedOption}
//                                                 className={css.fileUploadBtn}
//                                             />
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                         {/* <Col md={6} lg={6} sm={12} xs={12}>
//                             <StatCard
//                                 title={
//                                     activeTab === "institute"
//                                         ? "YUVA Students"
//                                         : "Thalir Students"
//                                 }
//                                 value={all_students}
//                                 icon={faUserGraduate}
//                                 gradient="linear-gradient(135deg,#6366f1,#8b5cf6)"
//                             />
//                         </Col> */}


//                         {/* <Col md={6} lg={6} sm={12} xs={12}>
//                             <StatCard
//                                 title="Onboarding Status"
//                                 value={
//                                     <div
//                                         style={{
//                                             display: "flex",
//                                             justifyContent: "space-between",
//                                             gap: "12px",
//                                         }}
//                                     >
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 flexDirection: "column",
//                                                 alignItems: "center",
//                                                 flex: 1,
//                                             }}
//                                         >
//                                             <span
//                                                 style={{
//                                                     fontSize: "12px",
//                                                     color: "#6b7280",
//                                                     fontWeight: "500",
//                                                     marginBottom: "4px",
//                                                 }}
//                                             >
//                                                 Total
//                                             </span>
//                                             <span
//                                                 style={{
//                                                     fontSize: "18px",
//                                                     color: "#1f2937",
//                                                     fontWeight: "600",
//                                                 }}
//                                             >
//                                                 {all_students_onboarding_onboarded +
//                                                     all_students_onboarding_invited +
//                                                     all_students_onboarding_pending}
//                                             </span>
//                                         </div>
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 flexDirection: "column",
//                                                 alignItems: "center",
//                                                 flex: 1,
//                                             }}
//                                         >
//                                             <span
//                                                 style={{
//                                                     fontSize: "12px",
//                                                     color: "#6b7280",
//                                                     fontWeight: "500",
//                                                     marginBottom: "4px",
//                                                 }}
//                                             >
//                                                 Onboarded
//                                             </span>
//                                             <span
//                                                 style={{
//                                                     fontSize: "18px",
//                                                     color: "#1f2937",
//                                                     fontWeight: "600",
//                                                 }}
//                                             >
//                                                 {all_students_onboarding_onboarded}
//                                             </span>
//                                         </div>
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 flexDirection: "column",
//                                                 alignItems: "center",
//                                                 flex: 1,
//                                             }}
//                                         >
//                                             <span
//                                                 style={{
//                                                     fontSize: "12px",
//                                                     color: "#6b7280",
//                                                     fontWeight: "500",
//                                                     marginBottom: "4px",
//                                                 }}
//                                             >
//                                                 Invited
//                                             </span>
//                                             <span
//                                                 style={{
//                                                     fontSize: "18px",
//                                                     color: "#1f2937",
//                                                     fontWeight: "600",
//                                                 }}
//                                             >
//                                                 {all_students_onboarding_invited}
//                                             </span>
//                                         </div>
//                                         <div
//                                             style={{
//                                                 display: "flex",
//                                                 flexDirection: "column",
//                                                 alignItems: "center",
//                                                 flex: 1,
//                                             }}
//                                         >
//                                             <span
//                                                 style={{
//                                                     fontSize: "12px",
//                                                     color: "#6b7280",
//                                                     fontWeight: "500",
//                                                     marginBottom: "4px",
//                                                 }}
//                                             >
//                                                 Pending
//                                             </span>
//                                             <span
//                                                 style={{
//                                                     fontSize: "18px",
//                                                     color: "#1f2937",
//                                                     fontWeight: "600",
//                                                 }}
//                                             >
//                                                 {all_students_onboarding_pending}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 }
//                                 icon={faUserCheck}
//                                 gradient="linear-gradient(135deg,#f59e0b,#f97316)"
//                             />
//                         </Col> */}
//                     </Row>
//                 </SecCard>
//             </div>

//             {/* Search and Filters Section */}
//             <div className={css.searchFiltersSection}>
//                 <div className={css.filtersContainer}>
//                     <div className={css.filterGroup}>
//                         <label className={css.filterLabel}>Search</label>
//                         <div className={css.searchInputWrapper}>
//                             <input
//                                 type="text"
//                                 value={searchQuery}
//                                 placeholder="Search from the list"
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 className={css.searchInput}
//                             />
//                         </div>
//                     </div>

//                     <div className={css.filterGroup}>
//                         <label className={css.filterLabel}>Region</label>
//                         <select
//                             value={filters.region}
//                             onChange={(e) => handleFilterChange("region", e.target.value)}
//                             className={css.filterSelect}
//                         >
//                             <option value="">All Regions</option>
//                             {uniqueRegions.map((region) => (
//                                 <option key={region} value={region}>
//                                     {region}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>

//                     <div className={css.filterGroup}>
//                         <label className={css.filterLabel}>College</label>
//                         <select
//                             value={filters.collegeName}
//                             onChange={(e) =>
//                                 handleFilterChange("collegeName", e.target.value)
//                             }
//                             className={css.filterSelect}
//                         >
//                             <option value="">All Colleges</option>
//                             {uniqueColleges.map((college) => (
//                                 <option key={college} value={college}>
//                                     {college}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>


//                     <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
//                         Clear All
//                     </button>
//                 </div>
//             </div>

//             <div className={css.filterBtns}>
//                 <div className={css.searchInputs}>
//                     <div className='d-flex' style={{ position: 'relative', justifyContent: 'end', alignItems: 'center' }}>
//                         <input
//                             type="text"
//                             value={searchQuery}
//                             placeholder="Search from the list"
//                             onChange={(e) => {
//                                 setSearchQuery(e.target.value);
//                                 // setPage(1);
//                             }}
//                             className={css.searchInput}
//                         />
//                         <FontAwesomeIcon icon={faMagnifyingGlass} style={{ color: "black", position: 'absolute', right: '10px' }} />
//                     </div>
//                 </div>
//             </div>
//             {isLoading ? (
//                 <Loader />
//             ) : (
//                 <div>
//                     <DataGrid
//                         rows={rows}
//                         columns={columns}
//                         pageSize={7} // Set the initial page size to 7
//                         pagination
//                     />
//                 </div>
//             )}

//             <YuvaEcAssignmentModal
//                 show={showEcModal}
//                 onHide={() => setShowEcModal(false)}
//                 student={selectedStudent}
//                 onSuccess={() => {
//                     setRerender(!rerender);
//                 }}
//             />
//         </div>
//     );
// };


// const ActionsDropdown = ({ onDownload, onUpload }) => {
//     const [isOpen, setIsOpen] = useState(false);

//     const toggleDropdown = () => setIsOpen(!isOpen);

//     // Close dropdown when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (!event.target.closest(`.${css.dropdownContainer}`)) {
//                 setIsOpen(false);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     return (
//         <div className={css.dropdownContainer}>
//             <button
//                 className={css.ellipsisBtn}
//                 onClick={toggleDropdown}
//                 aria-label="More actions"
//             >
//                 <FontAwesomeIcon icon={faEllipsisVertical} />
//             </button>

//             {isOpen && (
//                 <div className={css.dropdownMenu}>
//                     <button
//                         className={css.dropdownItem}
//                         onClick={() => {
//                             onDownload?.();
//                             setIsOpen(false);
//                         }}
//                     >
//                         <FontAwesomeIcon icon={faDownload} className={css.dropdownIcon} />
//                         Download Excel
//                     </button>
//                     <button
//                         className={css.dropdownItem}
//                         onClick={() => {
//                             onUpload?.();
//                             setIsOpen(false);
//                         }}
//                     >
//                         <FontAwesomeIcon icon={faUpload} className={css.dropdownIcon} />
//                         Upload Students
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default InstutueStudents;

import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import FileUpload from "../../components/common/FileUpload";
import { DataGrid } from '@mui/x-data-grid';
import Loader from "../../components/common/Loader";
import Badge from '@mui/material/Badge';
import axios from "axios";
import AsyncSelect from "react-select/async";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlus, faMagnifyingGlass, faEllipsisVertical,
    faDownload,
    faUpload,
    faUserCheck,
} from '@fortawesome/free-solid-svg-icons';
import { green, yellow, red } from '@mui/material/colors';
import { SERVER_ORIGIN, validation } from "../../utilities/constants";
import SecCard from "../../components/common/SecCard";
import { Row, Col } from "react-bootstrap";

import css from "../../css/admin/users-page.module.css";
import DownloadExcel from "../../components/common/DownloadExcel";
import YuvaEcAssignmentModal from "../../components/common/YuvaEcAssignmentModal";
import BackButton from "../../components/common/BackButton";
import { hasReadOnlyAccess, getManageStudentsPath, getDashboardPath } from "../../utilities/helper_functions";

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
}

const InstutueStudents = () => {
    const [searchParams] = useSearchParams();
    const tabFromUrl = searchParams.get("tab");
    const [activeTab, setActiveTab] = useState(tabFromUrl || "institute");
    const [instituteType, setInstituteType] = useState(null);
    const [queryId, setQueryId] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(0);
    const [allUsers, setAllUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [sortType, setSortType] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [totalPages, setTotalPages] = useState(0);
    const [rerender, setRerender] = useState(true);
    const isReadOnly = hasReadOnlyAccess();

    // YUVA EC Assignment Modal state
    const [showEcModal, setShowEcModal] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);

    // New state for filters
    const [filters, setFilters] = useState({
        region: "",
        state: "",
        onboardingStatus: "",
        emailStatus: "",
        collegeName: "",
    });

    // Upload and Download related states
    const [selectedOption, setSelectedOption] = useState(null);
    const [defaultOptions, setDefaultOptions] = useState([]);

    // File upload states
    const [excelData, setExcelData] = useState(null);
    const [showUploadButton, setShowUploadButton] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);

    function handelCreatedBy() {
        if (sessionStorage.getItem('token') !== null) {
            return sessionStorage.getItem('_id')
        } else {
            return ""
        }
    }

    // Get unique values for dropdowns
    const uniqueRegions = [
        ...new Set(allUsers.map((item) => item.region).filter(Boolean)),
    ];
    const uniqueColleges = [
        ...new Set(allUsers.map((item) => item.collegeName).filter(Boolean)),
    ];

    const renderOnboardingStatus = (params) => {
        let statusColor;
        let statusText;
        let textColor;

        switch (params.value) {
            case 'invited':
                statusColor = yellow[500];
                statusText = 'Invited';
                textColor = "black";
                break;
            case 'pending':
                statusColor = red[500];
                statusText = 'Pending';
                textColor = "white";
                break;
            case 'onboarded':
                statusColor = green[500];
                statusText = 'Onboarded';
                textColor = "white";
                break;
            default:
                statusColor = 'transparent';
                statusText = 'Unknown';
                textColor = "white";
        }
        return <Badge>
            <span style={{ backgroundColor: statusColor, padding: '6.4px 16px', borderRadius: '8px', color: textColor }}>
                {statusText}
            </span>
        </Badge>
    }

    const renderRegistrationType = (params) => {
        const isPublic = params.row.isPublicRegistration || false;
        return (
            <Badge>
                <span style={{
                    backgroundColor: isPublic ? "#007bff" : "#6c757d",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    color: "white",
                    fontSize: "11px",
                    fontWeight: "500"
                }}>
                    {isPublic ? "Public Link" : "Regular"}
                </span>
            </Badge>
        );
    };

    const renderYuvaECStatus = (params) => {
        const isEC = params.row.isYuvaEC || false;
        const ecPosition = params.row.yuvaEcPosition || "";
        const effectiveFrom = params.row.yuvaEcEffectiveFrom;
        const effectiveTo = params.row.yuvaEcEffectiveTo;

        const now = new Date();
        const fromDate = effectiveFrom ? new Date(effectiveFrom) : null;
        const toDate = effectiveTo ? new Date(effectiveTo) : null;
        const isActive = fromDate && toDate && now >= fromDate && now <= toDate;

        if (isEC && isActive) {
            return (
                <Badge>
                    <span style={{
                        backgroundColor: green[500],
                        padding: "6.4px 16px",
                        borderRadius: "8px",
                        color: "white",
                        fontSize: "12px"
                    }}>
                        {ecPosition || "YUVA EC"}
                    </span>
                </Badge>
            );
        } else if (isEC && !isActive) {
            return (
                <Badge>
                    <span style={{
                        backgroundColor: yellow[600],
                        padding: "6.4px 16px",
                        borderRadius: "8px",
                        color: "white",
                        fontSize: "12px"
                    }}>
                        Expired
                    </span>
                </Badge>
            );
        } else {
            return (
                <Badge>
                    <span style={{
                        backgroundColor: "#f5f5f5",
                        padding: "6.4px 16px",
                        borderRadius: "8px",
                        color: "#666",
                        fontSize: "12px"
                    }}>
                        Not Assigned
                    </span>
                </Badge>
            );
        }
    };

    const baseColumns = [
        { field: 'id', headerName: 'ID', align: 'center', width: 90 },
        { field: 'fName', headerName: 'Full Name', align: 'center', width: 170, valueGetter: (params) => `${params.row.fName || ''} ${params.row.lName || ''}`.trim() },
        { field: 'email', headerName: 'Email', align: 'center', width: 200 },
        { field: 'collegeName', headerName: 'Institute Name', align: 'center', width: 170 },
        { field: 'passOutYear', headerName: 'Passout Year', align: 'center', width: 150 },
        { field: 'chapterName', headerName: 'Chapter Name', align: 'center', width: 150 },
        { field: 'region', headerName: 'Region', align: 'center', width: 150 },
        { field: 'onboardingSatus', headerName: 'Onboarding Status', align: 'center', width: 160, renderCell: renderOnboardingStatus },
        { field: 'registrationType', headerName: 'Registration Type', align: 'center', width: 150, renderCell: renderRegistrationType },
        { field: 'gender', headerName: 'Gender', align: 'center', width: 110 },
        { field: 'branch', headerName: 'Branch', align: 'center', width: 110 },
        {
            field: 'lastLoginDate', headerName: 'Last Login', align: 'center', width: 170, valueGetter: (params) => {
                if (!params.value) return "Never";
                const date = new Date(params.value);
                return date.toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                });
            }
        },
        {
            field: "updatedAt",
            headerName: "Last Updated",
            align: "center",
            width: 140,
            valueGetter: (params) => params.row.updatedAt || params.row.createdAt || null,
            valueFormatter: (params) => {
                if (!params.value) return "-";
                const d = new Date(params.value);
                return d.toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                });
            },
        },

    ];

    const ecColumns = [
        {
            field: 'yuvaEcStatus',
            headerName: 'YUVA EC Status',
            align: 'center',
            width: 150,
            renderCell: renderYuvaECStatus,
        },
        {
            field: 'assignEC',
            headerName: 'Assign YUVA EC',
            type: 'actions',
            width: 180,
            align: 'center',
            renderCell: (params) => (
                <button
                    className={css.editBtn}
                    style={{ backgroundColor: '#28a745', border: 'none', color: 'white', padding: '6px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
                    onClick={() => { setSelectedStudent(params.row); setShowEcModal(true); }}
                >
                    Assign YUVA EC
                </button>
            )
        }
    ];

    const columns = activeTab === 'institute'
        ? [...baseColumns, ...ecColumns]
        : [...baseColumns];

    const rows = allUsers.map((user, idx) => ({ ...user, 'id': idx + 1 }))
    const navigate = useNavigate();

    function handleUsersClick() {
        navigate(`/user/register/${queryId}`);
    }

    useEffect(() => {
        async function getAllUsers() {
            try {
                setIsLoading(true);
                const _id = sessionStorage.getItem('_id');
                setQueryId(_id)
                const response = await fetch(
                    `${SERVER_ORIGIN}/api/institute/auth/users/all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=fName&sortType=${sortType === true ? "asc" : "desc"}`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": sessionStorage.getItem("token"),
                        }, body: JSON.stringify({ _id: _id }),
                    }
                );

                const result = await response.json();
                setIsLoading(false);

                if (response.status >= 400 && response.status < 600) {
                    if (response.status === 401) {
                        navigate("/");
                    } else if (response.status === 500) {
                        toast.error(result.statusText);
                    }
                } else if (response.ok && response.status === 200) {
                    setAllUsers(result.filteredUsers);
                    setTotalPages(result.totalPages);
                }
            } catch (err) {
                setIsLoading(false);
            }
        }
        getAllUsers();
    }, [page, sortType, searchQuery]);

    // UPLOAD AND DOWNLOAD FUNCTIONALITY
    const loadOptions = async (inputValue, callback) => {
        try {
            const response = await axios.get(`${SERVER_ORIGIN}/api/institute/auth/institute/all`, {
                params: {
                    search: inputValue,
                    page: 1,
                    limit: 10,
                    sortBy: "name",
                    sortType: "asc",
                    id: sessionStorage.getItem('_id'),
                    isThalir: activeTab === 'thalir' ? 'true' : 'false'
                }
            });
            const options = response.data.filteredInstitutes.map(institute => ({
                label: institute.name,
                value: institute._id,
                state: institute.state,
                city: institute.city
            }));
            callback(options);
        } catch (error) {
            console.error("Error fetching institutes", error);
        }
    };

    useEffect(() => {
        const fetchDefaultOptions = async () => {
            try {
                const response = await axios.get(`${SERVER_ORIGIN}/api/institute/auth/institute/all`, {
                    params: {
                        search: '',
                        page: 1,
                        limit: 5,
                        sortBy: "name",
                        sortType: "asc",
                        id: sessionStorage.getItem('_id'),
                        isThalir: activeTab === 'thalir' ? 'true' : 'false'
                    }
                });
                const options = response.data.filteredInstitutes.map(institute => ({
                    label: institute.name,
                    value: institute._id,
                    state: institute.state,
                    city: institute.city
                }));
                setDefaultOptions(options);
            } catch (error) {
                console.error("Error fetching default options", error);
            }
        };
        fetchDefaultOptions();
    }, [activeTab]);

    // Handle file selection and processing
    const handleFileSelect = (data) => {
        setExcelData(data);
        setShowUploadButton(true);
        toast.success("Excel data retrieved successfully. Press the 'Upload' button to upload the file.");
    };

    // Handle file upload
    const handleUpload = async () => {
        if (!excelData || !selectedOption) {
            toast.error("Please select an institute and ensure file data is loaded.");
            return;
        }

        try {
            setUploadLoading(true);
            const _id = sessionStorage.getItem('_id');

            const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/upload-students`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    excelData: excelData,
                    instituteId: selectedOption.value,
                    instituteName: selectedOption.label,
                    uploadedBy: _id
                }),
            });

            const result = await response.json();
            setUploadLoading(false);

            if (response.ok) {
                toast.success('Students uploaded successfully!');
                setShowUploadButton(false);
                setExcelData(null);
                // Refresh the user list
                setRerender(!rerender);
            } else {
                toast.error(result.message || 'Upload failed');
            }
        } catch (error) {
            setUploadLoading(false);
            toast.error('Upload failed. Please try again.');
        }
    };

    useEffect(() => {
        const getInstituteDetails = async () => {
            try {
                const _id = sessionStorage.getItem('_id');
                const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/users/${_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': sessionStorage.getItem('token'),
                    },
                });

                if (response.ok) {
                    const result = await response.json();
                    const isThalir = result.user?.isThalir || false;
                    setInstituteType(isThalir ? 'thalir' : 'institute');
                    setActiveTab(isThalir ? 'thalir' : 'institute');
                }
            } catch (error) {
                console.error('Error fetching institute details:', error);
            }
        };
        getInstituteDetails();
    }, []);

    // Handle filter changes
    const handleFilterChange = (filterName, value) => {
        setFilters((prev) => ({
            ...prev,
            [filterName]: value,
        }));
    };

    // Clear all filters
    const clearAllFilters = () => {
        setFilters({
            region: "",
            state: "",
            onboardingStatus: "",
            emailStatus: "",
            collegeName: "",
        });
        setSearchQuery("");
    };

    return (
        <div className={css.outerDiv}>
            <div className={css.headerSection}>
                <div className={css.headerLeft}>
                    <BackButton
                        text="Back to Dashboard"
                        customPath={getDashboardPath()}
                    />
                </div>
            </div>

            {isReadOnly && (
                <div className={css.readOnlyAlert}>
                    <div className="alert alert-info" role="alert">
                        <strong>Read-Only Access:</strong> You can view all student data but
                        cannot add, edit, or upload new students.
                    </div>
                </div>
            )}

            <div className="my-4">
                <SecCard>
                    <Row className="g-4">
                        <div className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}>
                            <div className={css.serviceName}>Students Data</div>

                            <div className={css.headerRightSection}>
                                {!isReadOnly && (
                                    <div className={css.actionButtons}>
                                        <button className={css.addBtn} onClick={handleUsersClick}>
                                            <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                                            Add Student
                                        </button>

                                        {/* <ActionsDropdown
                                            onDownload={() => document.querySelector(`.${css.downloadExcelBtn}`)?.click()}
                                            onUpload={() => document.querySelector(`.${css.fileUploadBtn}`)?.click()}
                                        /> */}

                                        <div style={{ display: "none" }}>
                                            <DownloadExcel className={css.downloadExcelBtn} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* UPLOAD AND DOWNLOAD CONTROLS INTEGRATED HERE */}
                        <div className={css.uploadDownloadSection}>
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <div style={{ marginBottom: "1rem" }}>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={loadOptions}
                                            defaultOptions={defaultOptions}
                                            onChange={(selectedOption) => {
                                                setSelectedOption(selectedOption);
                                            }}
                                            value={selectedOption}
                                            placeholder="Select / Search Institute"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="d-flex justify-content-end gap-3 align-items-center">
                                        <DownloadExcel />

                                        {/* Custom File Upload with Upload Button */}
                                        <div className="d-flex gap-2 align-items-center">
                                            <FileUpload
                                                onFileProcessed={handleFileSelect}
                                                collegeName={selectedOption}
                                            />

                                            {showUploadButton && (
                                                <button
                                                    className={`${css.uploadBtn} commonBtn`}
                                                    onClick={handleUpload}
                                                    disabled={uploadLoading || !selectedOption}
                                                >
                                                    {uploadLoading ? (
                                                        <span>Uploading...</span>
                                                    ) : (
                                                        <>
                                                            <FontAwesomeIcon icon={faUpload} style={{ color: "#ffffff", marginRight: "5px" }} />
                                                            Upload Data
                                                        </>
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </SecCard>
            </div>

            {/* Search and Filters Section */}
            <div className={css.searchFiltersSection}>
                <div className={css.filtersContainer}>
                    <div className={css.filterGroup}>
                        <label className={css.filterLabel}>Search</label>
                        <div className={css.searchInputWrapper}>
                            <input
                                type="text"
                                value={searchQuery}
                                placeholder="Search from the list"
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className={css.searchInput}
                            />
                        </div>
                    </div>

                    <div className={css.filterGroup}>
                        <label className={css.filterLabel}>Region</label>
                        <select
                            value={filters.region}
                            onChange={(e) => handleFilterChange("region", e.target.value)}
                            className={css.filterSelect}
                        >
                            <option value="">All Regions</option>
                            {uniqueRegions.map((region) => (
                                <option key={region} value={region}>
                                    {region}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={css.filterGroup}>
                        <label className={css.filterLabel}>College</label>
                        <select
                            value={filters.collegeName}
                            onChange={(e) => handleFilterChange("collegeName", e.target.value)}
                            className={css.filterSelect}
                        >
                            <option value="">All Colleges</option>
                            {uniqueColleges.map((college) => (
                                <option key={college} value={college}>
                                    {college}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
                        Clear All
                    </button>
                </div>
            </div>

            {isLoading ? (
                <Loader />
            ) : (
                <div>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={7}
                        pagination
                    />
                </div>
            )}

            <YuvaEcAssignmentModal
                show={showEcModal}
                onHide={() => setShowEcModal(false)}
                student={selectedStudent}
                onSuccess={() => {
                    setRerender(!rerender);
                }}
            />
        </div>
    );
};

const ActionsDropdown = ({ onDownload, onUpload }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(`.${css.dropdownContainer}`)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={css.dropdownContainer}>
            <button
                className={css.ellipsisBtn}
                onClick={toggleDropdown}
                aria-label="More actions"
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>

            {isOpen && (
                <div className={css.dropdownMenu}>
                    <button
                        className={css.dropdownItem}
                        onClick={() => {
                            onDownload?.();
                            setIsOpen(false);
                        }}
                    >
                        <FontAwesomeIcon icon={faDownload} className={css.dropdownIcon} />
                        Download Excel
                    </button>
                    <button
                        className={css.dropdownItem}
                        onClick={() => {
                            onUpload?.();
                            setIsOpen(false);
                        }}
                    >
                        <FontAwesomeIcon icon={faUpload} className={css.dropdownIcon} />
                        Upload Students
                    </button>
                </div>
            )}
        </div>
    );
};

export default InstutueStudents;